import { render, staticRenderFns } from "./StatisticsFeesFilters.vue?vue&type=template&id=a5fd5e52&"
import script from "./StatisticsFeesFilters.vue?vue&type=script&lang=js&"
export * from "./StatisticsFeesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports